<template>
    <div class="select-default">
        <Multiselect
            v-model="val"
            :show-labels="false"
            deselect-label="Can't remove this value"
            track-by="name"
            label="name"
            placeholder="Select one"
            :options="options"
            :searchable="false"
            :allow-empty="false"
            @change="handleChange"
        >
            <template slot="singleLabel" slot-scope="{ option }">
                {{ option.name }}
            </template>
        </Multiselect>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
export default {
    components: {
        Multiselect,
    },
    props: {
        value: {
            type: Object,
            required: false,
            default: () => ({
                name: 'Option1',
                value: 'option1',
            }),
        },
        options: {
            type: Array,
            required: false,
            default: () => [
                {
                    name: 'Option1',
                    value: 'option1',
                },
                {
                    name: 'Option2',
                    value: 'option2',
                },
                {
                    name: 'Option3',
                    value: 'option3',
                },
            ],
        },
    },

    computed: {
        val: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit('change', newValue);
            },
        },
    },
    model: {
        prop: 'value',
        event: 'change',
    },
    methods: {
        handleChange(value) {
            this.$emit('change', value);
        },
    },
};
</script>
